const FeesAndFunding = () => {
    return (
        <>
            <div className="about-ed-wrapper-impact">
                <h2 className="about-ed-heading-impact">Fees And Funding</h2>
                <div className="about-ed-block-impact">
                    <div className="about-ed-role-impact">Author Fees</div>
                    <div className="about-ed-content-impact">
                        <ul>
                            <li><p>This journal follows a transparent fee policy as outlined below:</p>
                                <p><i className="fas fa-chevron-right"></i>Article Submission Fee: ₹0.00 (INR)</p>
                                <p>Authors are not required to pay any fee at the time of manuscript submission. There is no charge for submitting an article,
                                    and no payment is requested during the peer review process.
                                </p>
                            </li>
                            <li>
                                <p><i className="fas fa-chevron-right"></i>Article Publication Fee:</p>
                                <p>If the manuscript is accepted for publication, authors will be required to pay a publication fee, which contributes to the
                                    editorial, production, and hosting costs associated with the final published article.</p>
                            </li>
                        </ul>
                        <div className="about-ed-table-container-impact">
                            <table className="about-ed-table-impact">
                                <thead>
                                    <tr>
                                        <th>Article Category</th>
                                        <th>Publication fee</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Original Research Article</td>
                                        <td> <p>
                                            ₹1199 <span className="amount-1500-cancel">₹1500</span> <span>Limited time offer</span>
                                        </p></td>
                                    </tr>
                                    <tr>
                                        <td>Review Article</td>
                                        <td> <p>
                                            ₹1199 <span className="amount-1500-cancel">₹1500</span> <span>Limited time offer</span>
                                        </p></td>
                                    </tr>
                                    <tr>
                                        <td>Case Study</td>
                                        <td> <p>
                                            ₹1199 <span className="amount-1500-cancel">₹1500</span> <span>Limited time offer</span>
                                        </p></td>
                                    </tr>
                                    <tr>
                                        <td>Short Communication</td>
                                        <td> <p>
                                            ₹1199 <span className="amount-1500-cancel">₹1500</span> <span>Limited time offer</span>
                                        </p></td>
                                    </tr>
                                    <tr>
                                        <td>Book Chapter</td>
                                        <td> <p>
                                            ₹1199 <span className="amount-1500-cancel">₹1500</span> <span>Limited time offer</span>
                                        </p></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FeesAndFunding